import PhotoStrip from '@app/components/PhotoStrip'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { IDevelopmentClientViewState } from '../modules/developmentClientDetail'

type IComponentProps = IDevelopmentClientViewState &
  RouteComponentProps<{ clientSlug: string }>

class DevelopmentClientPhotos extends React.PureComponent<IComponentProps> {
  public render() {
    if (!this.props.item) {
      return null
    }

    return (
      <div>
        <div className='mx-2'>
          <PhotoStrip photos={this.props.item.photos} />
        </div>
      </div>
    )
  }
}

export default withRouter(DevelopmentClientPhotos)
